// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/dietz-sagt-hallo-bei-linkedin-und-xing/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const dietzSagtHalloBeiLinkedinUndXingDE: PageEntry = {
  id: "post.dietz-sagt-hallo-bei-linkedin-und-xing",
  locale: "de",
  slug: "dietz-sagt-hallo-bei-linkedin-und-xing",
  seo: {
    title: "„Dietz sagt Hallo bei LinkedIn und Xing“ | Dietz GmbH",
    description: "„Dietz sagt Hallo bei LinkedIn und Xing“",
  },
  type: "post",
  h1: "„Dietz sagt Hallo bei LinkedIn und Xing“",
  blocks: [
    { kind: "heading", level: 2, text: "„Dietz sagt Hallo bei LinkedIn und Xing“" },
    { kind: "paragraph", text: "Ab sofort sind wir auch auf XING und LinkedIn vertreten." },
    { kind: "paragraph", text: "Hier zeigen wir, was eigentlich hinter der Dietz GmbH aus Neustadt bei Coburg steckt und gewähren zudem exklusive Einblicke hinter die Kulissen. Erfahren Sie mehr über unsere Unternehmensphilosophie und Produkte." },
    { kind: "paragraph", text: "Bleiben Sie informiert und folgen Sie unseren Social Media Kanälen." }
  ],
};
